// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SaveOrder: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13">
            <path
                fill="currentColor"
                d="M5.25 11.375c0-.621-.504-1.125-1.125-1.125s-1.083.504-1.083 1.125A1.12 1.12 0 0 0 4.146 12.5c.6 0 1.104-.504 1.104-1.125Zm8.098-9.827a.754.754 0 0 0-.62-.298h-4.29v2.393l.54-.54a.562.562 0 1 1 .795.796l-1.5 1.5a.56.56 0 0 1-.796-.001l-1.5-1.5a.562.562 0 1 1 .796-.796l.54.541V1.25H2.838L2.803.957A.564.564 0 0 0 2.25.5H.541A.554.554 0 0 0 0 1.041c0 .29.252.584.541.584h1.222l1.413 7.418a.605.605 0 0 0 .574.457h7.688c.31 0 .562-.252.562-.541a.566.566 0 0 0-.562-.584H4.216L4.001 7.25h7.462a.75.75 0 0 0 .721-.544l1.286-4.479a.777.777 0 0 0-.122-.679Zm-2.494 8.702c-.621 0-1.104.504-1.104 1.125a1.12 1.12 0 0 0 1.104 1.125c.6 0 1.104-.504 1.104-1.125s-.462-1.125-1.104-1.125Z"
                opacity=".66"
            />
        </svg>
    );
};

export default React.memo(SaveOrder);
